export const pageSizes = [
    {label: 10, value: 10},
    {label: 20, value: 20}
];
export const messageTypeList = [
    {
        label: '系统消息',
        name: 'system'
    },
    {
        label: '我的消息',
        name: 'personal'
    }
];
// 未读消息
export const UNREAD = 0;
// 忽略，一定是未读消息
export const IGNORE = 1;
// 已读消息
export const READ = 2;
